<template>
    <fragment>
        <div
            v-for="(toasts, position) in toastsByPosition"
            :key="position"
            class="fixed z-500 flex flex-col gap-2 pointer-events-none"
            :class="positionClasses[position]"
        >
            <transition-group
                name="toast"
                tag="div"
                class="flex flex-col gap-2"
            >
                <div
                    v-for="item in toasts"
                    :key="item.id"
                    class="pointer-events-auto flex items-start gap-2 bg-theme-card text-theme-base border border-theme-border rounded-lg shadow-lg px-4 py-3 max-w-90vw w-80"
                >
                    <span v-if="item.icon" class="text-xl leading-none">
                        {{ item.icon }}
                    </span>
                    <div class="flex-1 min-w-0">
                        <p v-if="item.title" class="font-semibold text-sm">
                            {{ item.title }}
                        </p>
                        <p
                            v-if="item.text"
                            class="text-sm text-theme-muted mt-1"
                        >
                            {{ item.text }}
                        </p>
                        <button
                            v-if="item.action"
                            type="button"
                            class="btn btn-stack-primary mt-2"
                            @click="runAction(item)"
                        >
                            {{ item.action.label }}
                        </button>
                    </div>
                    <button
                        type="button"
                        aria-label="Cerrar notificación"
                        class="text-theme-muted hover:text-theme-base leading-none"
                        @click="close(item.id)"
                    >
                        ✕
                    </button>
                </div>
            </transition-group>
        </div>
    </fragment>
</template>

<script>
import { remove, toastState } from "@/plugins/toast";

export default {
    name: "AppToastHost",
    data: () => ({
        toastState,
        positionClasses: {
            "bottom-right": "bottom-4 right-4 items-end",
            "bottom-center":
                "bottom-4 left-1/2 transform -translate-x-1/2 items-center",
            "top-right": "top-4 right-4 items-end"
        }
    }),
    computed: {
        toastsByPosition() {
            return this.toastState.toasts.reduce((groups, item) => {
                (groups[item.position] = groups[item.position] || []).push(
                    item
                );
                return groups;
            }, {});
        }
    },
    methods: {
        close(id) {
            remove(id);
        },
        runAction(item) {
            item.action.handler();
            this.close(item.id);
        }
    }
};
</script>
